import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { Agendar } from "../interfaces/entities/Agendar";
import { City } from "../interfaces/entities/City";
import { Doctor } from "../interfaces/entities/Doctor";
import { FilterInterface } from "../interfaces/entities/FilterInterface";
import { GuiaMedicoComAgendamento } from "../interfaces/entities/GuiaMedicoComAgendamento";
import { Horarios } from "../interfaces/entities/Horarios";
import { RetornaAceiteTermoTeleMedicina } from "../interfaces/entities/RetornaAceiteTermoTeleMedicina";
import { States } from "../interfaces/entities/States";
import { TermsOfUse } from "../interfaces/entities/TermsOfUse";
import { RespostaTriagemPaVirtual } from "../interfaces/entities/RespostaTriagemPaVirtual";
import { ParametrosAgendamentoPaVirtual } from "../interfaces/entities/PAVirtual/ParametrosAgendamentoPaVirtual";
import { Response } from "../interfaces/services/Response";
import { GuiaMedicoBody } from "../interfaces/entities/GuiaMedicoBody";

export const getEspecAgendOnLineTele = async (): Promise<FilterInterface[] | null> => {
  try {
    const response = await apiClientes.get('/GuiaMedico/GetEspecAgendOnLineTele', { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getEspecialidadeGuiaEncaminhamentoPlanoMais = async (): Promise<FilterInterface[] | null> => {
  try {
    const response = await apiClientes.get('/GuiaMedico/GetEspecialidadeGuiaEncaminhamentoPlanoMais', { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getCidades = async (): Promise<FilterInterface[] | null> => {
  try {
    const response = await apiClientes.get('/GuiaMedico/GetCidades', { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getEspecialidades = async (): Promise<FilterInterface[] | null> => {
  try {
    const tipo = 0;
    const idCidade = 53;
    const response = await apiClientes.get('GuiaMedico/GetEspecialidades', {params: {tipo, idCidade}, headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getTiposServiço = async (): Promise<FilterInterface[] | null> => {
  try {
    const response = await apiClientes.get('GuiaMedico/GetTiposServicos', { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getMedicos = async (nome: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/GuiaMedico/BuscarMedico', {
      nome,
      start: 0,
      limit: 1000
    }, { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getPrestadoresPlanoMais = async (): Promise<Doctor[] | null> => {
  try {
    const response = await apiClientes.get('/GuiaMedico/GetPrestadoresPlanoMais', { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getEnfermeirosPlanoMais = async (): Promise<Doctor[] | null> => {
  try {
    const response = await apiClientes.get('/GuiaMedico/GetEnfermeirosPlanoMais', { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const buscarGuiaMedicoComAgendamento = async (body: GuiaMedicoComAgendamento): Promise<Doctor[] | null> => {
  try {
    const response = await apiClientes.post('/GuiaMedico/BuscarGuiaMedicoComAgendamento', body, { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const buscarGuiaMedico = async (body: GuiaMedicoBody): Promise<Doctor[]> => {
  return new Promise(async (resolve, reject) => {
    try {
      const payload = {
        nome: body.nome,
        tipoAtend: body.tipoAtend,
        tipoServico: body.tipoServico ? body.tipoServico : 'TODOS',
        especialidade: body.especialidade,
        cidade: body.cidade,
        start: body.start.toString(),
        limit: (body.limit - 2).toString(), // o (- 2) é porque a API sempre traz dois resultados além do que a gente pediu
        isFavorito: body.isFavorito ? 'S' : undefined,
        queryText: body.search,
        order: body.order,
        latitude: 0,
        longitude: 0
      }
      
      const response = await apiClientes.post('/GuiaMedico/BuscarGuiaMedico', payload, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });

      if (response?.data?.itemGuiaMedico) {
        resolve(response.data?.itemGuiaMedico);
      } else {
        reject(response);
      }
    } catch (error) {
      reject(error);
    }
  })
  
};

export const cadastroFavorito = async (id: string): Promise<Response[] | null> => {
  try {
    const response = await apiClientes.post('/GuiaMedico/CadMedicoFavoritoGuiaMedico', { id }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response.data;
  } catch (error) {
    return null;
  }
}

export const removeFavorito = async (id: string): Promise<Response[] | null> => {
  try {
    const response = await apiClientes.post('/GuiaMedico/RemoveMedicoFavoritoGuiaMedico', { id }, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
    return response.data;
  } catch (error) {
    return null;
  }
}


export const getHorariosDisponiveisPeriodo = async (
  idPrestador: string, 
  idInstal: string, 
  dtInicial: Date, 
  dtFinal: Date,
  tipoAtend: string,
): Promise<Horarios[] | null> => {
  try {
    const response = await apiClientes.get('/Agenda/GetHorariosDisponiveisPeriodo', {
      params: {
        idPrestador,
        idInstal,
        dtInicial,
        dtFinal,
        tipoAtend,
      },
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const retornaTermoTelemedicina = async (): Promise<TermsOfUse | null> => {
  try {
    const response = await apiClientes.get('/TermoResponsabilidade/RetornaTermoTelemedicina', {
      params: { idAgenda: '' },
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const retornaAceiteTermoTeleMedicina = async (): Promise<RetornaAceiteTermoTeleMedicina | null> => {
  try {
    const response = await apiClientes.get('/TermoResponsabilidade/RetornaAceiteTermoTeleMedicina', {
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getCidadeExecucaoExame = async (idUf: string, filtro: ''): Promise<City[] | null> => {
  try {
    const response = await apiClientes.get('/Agenda/GetCidadeExecucaoExame', {
      params: { idUf, filtro },
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getEstadoExecucaoExame = async (): Promise<States[] | null> => {
  try {
    const response = await apiClientes.get('/Agenda/GetEstadoExecucaoExame', {
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const agendar = async (body: Agendar): Promise<string | null> => {
  try {
    const response = await apiClientes.post('/Agenda/Agendar', body, { headers: { Authorization: `Bearer ${ await getTokenClientes()}` } });
    return response.data; // Retornar o valor da resposta, não a resposta completa

  } catch (error: any) {
    console.log({ error });
    const err = { error }
    return err.error.response.data.mensagem;
  }
};

export const getHorariosMock = async (): Promise<Horarios[] | null> => { //Teleorientação em saúde
  try {

    const horarios: Horarios[] = [];
    const data = "05/01/2024";
    const diaSemana = "Sexta";
    const intervaloMinuto = "30";
    const indPermiteRet = "S";

    for (let hora = 8; hora <= 16; hora++) {
      const horaFormatada = hora < 10 ? `0${hora}` : `${hora}`;
      const horario: Horarios = {
        idPrestador: '',
        idInstal: '',
        data,
        hora: `${horaFormatada}:00`,
        diaSemana,
        intervaloMinuto,
        indPermiteRet,
      };

      horarios.push(horario);
    }

    return horarios;

  } catch (error) {
    console.log({ error });
    return null;
  }
};

/*PA VIRTUAL*/
export const getDisponibilidadePaVirtual = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/pavirtual/getdisponibilidadepavirtualv2', {
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return null;
  }
};

export const retornaAceiteTermoPaVirtual = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/termoresponsabilidade/retornaaceitetermopavirtual', {
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const retornaTermoPaVirtual = async (): Promise<any> => {
  try {
    const response = await apiClientes.get('/termoresponsabilidade/retornatermoresponsabilidadepavirtual', {
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response.data;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const aceitaTermoResponsabilidade = async (idTermo: string, indAceite: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/termoresponsabilidade/aceitatermoresponsabilidade', {
      params: { idTermo, indAceite },
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getTipoOrientacaoTriagem = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/pavirtual/gettipoorientacaotriagem', {
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const getTriagem = async (codTipoTeleOrientacao: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/pavirtual/gettriagem', {
      params: { codTipoTeleOrientacao },
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
};


export const getTriagemDengue = async (codTipoTeleOrientacao: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/pavirtual/gettriagem', {
      params: { codTipoTeleOrientacao },
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error) {
    console.log({ error });
    return null;
  }
};



export const salvarRespQuest = async (respostas: RespostaTriagemPaVirtual[]): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/pavirtual/salvarrespquest', respostas, {
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getEstadoTriagem = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/pavirtual/getestadotriagem', {
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getCidadeTriagem = async (idUf: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/pavirtual/getcidadetriagem', {
      params: { idUf },
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getDirecionamento = async (idRespQuestBenef: string, codTipoTeleOrientacao: string | null): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/pavirtual/retdirecionamentov2', {
      params: { idRespQuestBenef, codTipoTeleOrientacao },
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getQuestoesRetorno = async (): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/pavirtual/getquestoesretorno', {
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getHorariosDisponiveisPeriodoPa = async (dtInicial: Date, dtFinal: Date): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/pavirtual/gethorariosdisponiveisperiodo', {
      params: {
        dtInicial,
        dtFinal
      },
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;

  } catch (error) {
    console.log({ error });
    return null;
  }
};

export const agendamentoPaVirtual = async (parametrosAgendamento: ParametrosAgendamentoPaVirtual): Promise<Response | null> => {
  try {
    const response = await apiClientes.post('/pavirtual/agendamentopavirtual', parametrosAgendamento, {
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const agendarPaVirtualAgenda = async (parametrosAgendamento: ParametrosAgendamentoPaVirtual): Promise<Response | null> => {
  //REQUISIÇÃO PARA QUANDO PA VIRTUAL É UM ATENDIMENTO INFANTIL
  try {
    const response = await apiClientes.post('/pavirtual/agendarpavirtualagenda', parametrosAgendamento, {
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
};

export const getPosicaoFilaAgendamento = async (idAgenda: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/pavirtual/posicaofilaagendamento', {
      params: {
        idAgenda
      },
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;

  } catch (error: any) {
    console.log({ error });
    return error;
  }
};

export const cancelaAtendimentoPaVirtual = async (idAgenda: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/pavirtual/cancelaatendimentopavirtual', {
      params: {
        idAgenda
      },
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error;
  }
};

export const fimAtendPaVirtual = async (idAgenda: string): Promise<Response | null> => {
  try {
    const response = await apiClientes.get('/pavirtual/fimatendpavirtual', {
      params: {
        idAgenda
      },
      headers: { Authorization: `Bearer ${ await getTokenClientes()}` }
    });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error;
  }
};

/*PA VIRTUAL*/ 